import React, { useState } from "react";
import ReactDOM from "react-dom";
import Draggable from "react-draggable";

export const Dashboard = ({ body, size, draggable = true }) => {
  const handleStart = (e) => {
    const a = (activeDrags += activeDrags);
    setActiveDrags(a);
  };
  const handleDrag = (e) => {
    console.log("this.................................. Drag", e);
  };
  const handleStop = (e) => {
    const a = (activeDrags -= activeDrags);
    setActiveDrags(a);
  };
  let [activeDrags, setActiveDrags] = useState();
  const dragHandlers = { onStart: handleStart, onStop: handleStop };

  // onStart = () => {
  //   setState({activeDrags: ++this.state.activeDrags});
  //   setActiveDrags(++activeDrags)
  // };

  // onStop = () => {
  //   setState({activeDrags: --this.state.activeDrags});
  //   setActiveDrags(--activeDrags)
  // };
  // onDrop = (e) => {
  //   setState({activeDrags: --this.state.activeDrags});
  //   setActiveDrags(--activeDrags)
  //   if (e.target.classList.contains("drop-target")) {
  //     alert("Dropped!");
  //     e.target.classList.remove('hovered');
  //   }
  // };

  // const container = document.querySelector('.container');
  // const element = document.querySelector('.element');

  // const containerWidth = container.clientWidth;
  // const containerHeight = container.clientHeight;
  // const elementWidth = element.clientWidth;
  // const elementHeight = element.clientHeight;

  // const centerX = (containerWidth - elementWidth) / 2;
  // const centerY = (containerHeight - elementHeight) / 2;

  // element.style.position = 'absolute';
  // element.style.left = `${centerX}px`;
  // element.style.top = `${centerY}px`;

  return (
    <Draggable
      disabled={!draggable}
      cancel="input, textarea, select, button, p"
      // bounds="parent"
      {...dragHandlers}
      // axis="x"
      // handle=".handle"
      // defaultPosition={{x: 879, y: -417}}
      // defaultPosition={{ x: 120, y: 70 }}
      // position={null}
      // grid={[25, 25]}
      // scale={1}
      // onStart={handleStart}
      // onDrag={handleDrag}
      // onStop={handleStop}

      bounds={{
        left: -1200,
        top: -500,
        right: window.innerWidth - 700,
        bottom: window.innerHeight - (size === "large" ? 300 : 500),
      }}
    >
      {body}
    </Draggable>
  );
};

export default Dashboard;
